import { CommonModule, NgFor } from '@angular/common'
import {
  Component,
  EnvironmentInjector,
  inject,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { DialogComponent } from '../dialog/dialog.component'
import { take } from 'rxjs'

@Component({
  selector: 'app-declare',
  imports: [NgFor, CommonModule, ReactiveFormsModule],
  templateUrl: './declare.component.html',
  styleUrl: './declare.component.scss'
})
export class DeclareComponent implements OnInit {
  private injector = inject(EnvironmentInjector)
  financialYears: string[] = []
  selectedFinancialYear = new FormControl('', { nonNullable: true })
  investmentsLockedAt: string | null = null
  @ViewChild('dialogBoxHolder', { read: ViewContainerRef, static: false })
  private container!: ViewContainerRef
  sectionsAndSchemes = [
    {
      name: 'Section 80C',
      description: 'Section 80C',
      maxLimit: 150000,
      limitUsed: 0,
      schemesAppliedFor: 0,
      schemes: [
        {
          name: 'Life Insurance Premium',
          description: 'Life Insurance Premium',
          amount: 0,
          proofs: [],
          isActive: true,
          appliedFor: false
        }
      ],
      isActive: true
    }
  ]

  ngOnInit(): void {
    this.setupFinancialYears()
    //this.loadBusinessesList()
    //this.listenForSelectionChanges()
    //this.subscribeToPayrollBatches()
    //this.initializePaymentDetailsForm()
  }

  toggleLockStatus() {
    if (this.investmentsLockedAt) {
      this.investmentsLockedAt = null
      // Call a service to update the backend
    } else {
      this.investmentsLockedAt = new Date().toISOString()
      // Call a service to update the backend
    }
  }

  addDialog(scheme: any) {
    const compRef = this.container.createComponent(DialogComponent, {
      injector: this.injector
    })
    //compRef.instance.text = 'Hello inside the div!'

    compRef.instance.destroyMe.pipe(take(1)).subscribe(() => compRef.destroy())
  }

  private setupFinancialYears(): void {
    const currentYear = new Date().getFullYear()
    const START_YEAR = 2023 // Adjust as needed

    for (let year = START_YEAR; year <= currentYear + 1; year++) {
      this.financialYears.unshift(`${year - 1}-${year}`)
    }
    if (this.financialYears.length > 0) {
      this.selectedFinancialYear.setValue(this.financialYears[0])
    }
  }
}
